var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dropdownActive),expression:"dropdownActive"}],ref:"dropdown",staticClass:"select-items scroll-container",class:{
    'select-items_small': _vm.small,
    'select-items_large': _vm.large
  },style:(_vm.cssStyles)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }